<div class="font-weight-bolder font-size-14">{{description}}</div>
<div class="font-size-xs">
  <app-ui-product-range-name [name]="name"></app-ui-product-range-name>
</div>
